import { render, staticRenderFns } from "./BuscarDocumentosND.vue?vue&type=template&id=61315193&scoped=true"
import script from "./BuscarDocumentosND.vue?vue&type=script&lang=js"
export * from "./BuscarDocumentosND.vue?vue&type=script&lang=js"
import style0 from "./BuscarDocumentosND.vue?vue&type=style&index=0&id=61315193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61315193",
  null
  
)

export default component.exports